import { FONT_WEIGHT } from 'parkway-web-common'
import styled from 'styled-components'

export const TextItemCategory = styled.span`
  color: var(--states-red-color);
  font-weight: ${FONT_WEIGHT.bold};
`
